import InputField from "components/FormFields/InputField";
import { PayoutMethodEnum } from "enum/common";
import React from "react";

const CanadianEftBankForm: React.FC<{ formikRef: any }> = ({ formikRef }) => {
  const { handleSubmit, setFieldValue, values, touched, errors } = formikRef;
  return (
    <form
      onSubmit={handleSubmit}
      className="flex flex-col"
      id={`${PayoutMethodEnum.CANADA_EFT}-bank`}
    >
      <div className="text-darkBlue text-sm font-semibold mb-3">
        Step 2: Bank Account information
      </div>
      <InputField
        onChange={(e) => {
          setFieldValue("financialInstitutionNumber", e.target.value);
        }}
        value={values?.financialInstitutionNumber}
        label={"Financial Insttituion Number"}
        placeholder="Enter Financial Insttituion Number"
        id={""}
        error={
          touched.financialInstitutionNumber &&
          errors.financialInstitutionNumber
        }
      />
      <InputField
        onChange={(e) => {
          setFieldValue("transitNumber", e.target.value);
        }}
        value={values?.transitNumber}
        label={"Transit Number"}
        placeholder="Enter Transit Number"
        id={""}
        error={touched.transitNumber && errors.transitNumber}
      />
      <InputField
        onChange={(e) => {
          setFieldValue("accountNumber", e.target.value);
        }}
        value={values?.accountNumber}
        label={"Account Number"}
        placeholder="Enter Account Number"
        id={""}
        error={touched.accountNumber && errors.accountNumber}
      />
      <InputField
        onChange={(e) => {
          setFieldValue("accountName", e.target.value);
        }}
        value={values?.accountName}
        label={"Account Name"}
        placeholder="Enter Account Name"
        id={""}
        error={touched.accountName && errors.accountName}
      />
    </form>
  );
};

export default CanadianEftBankForm;
